import { apiJson, replaceUserEndpoint } from './userEndpoint';

function trainerUrl(template, { userId, fitnessProfileId, briefingId, csrfToken, method, body }) {
	const url = replaceUserEndpoint(template, { userId, fitnessProfileId });
	const finalUrl =
		briefingId != null
			? url.replace(/:briefing_id|briefing_id/g, String(briefingId))
			: url;

	return apiJson(finalUrl, { method, csrfToken, body });
}

export function fetchTrainer({ userId, fitnessProfileId, endpoint, csrfToken }) {
	return trainerUrl(endpoint, { userId, fitnessProfileId, csrfToken });
}

export function updateTrainerSettings({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	settings
}) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'PATCH',
		body: settings
	});
}

export function clearTrainerChat({ userId, fitnessProfileId, endpoint, csrfToken }) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'DELETE'
	});
}

export function sendTrainerChat({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	message,
	clientTimeZone
}) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'POST',
		body: { message, client_time_zone: clientTimeZone || detectBrowserTimeZone() }
	});
}

export function analyzeTrainerMeal({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	image,
	userNote
}) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'POST',
		body: { image, user_note: userNote }
	});
}

export function acceptTrainerChallenge({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	confirmationToken
}) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'POST',
		body: { confirmation_token: confirmationToken }
	});
}

export function dismissTrainerBriefing({
	userId,
	fitnessProfileId,
	briefingId,
	endpoint,
	csrfToken
}) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		briefingId,
		csrfToken,
		method: 'PATCH'
	});
}

export function snoozeTrainerNudges({ userId, fitnessProfileId, endpoint, csrfToken, hours, clear = false }) {
	return trainerUrl(endpoint, {
		userId,
		fitnessProfileId,
		csrfToken,
		method: 'PATCH',
		body: clear ? { clear: true } : { hours }
	});
}

export function formatTrainerSnoozeUntil(isoString, timeZone) {
	if (!isoString) return null;

	try {
		return new Intl.DateTimeFormat(undefined, {
			weekday: 'short',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			timeZone: timeZone || undefined
		}).format(new Date(isoString));
	} catch {
		return new Date(isoString).toLocaleString();
	}
}

export function detectBrowserTimeZone() {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York';
	} catch {
		return 'America/New_York';
	}
}

export function commonTimeZoneOptions() {
	return [
		'America/New_York',
		'America/Chicago',
		'America/Denver',
		'America/Los_Angeles',
		'America/Phoenix',
		'America/Anchorage',
		'Pacific/Honolulu'
	];
}
